import { get } from 'lodash';
import { Component, Injector, Input, OnChanges, OnDestroy } from '@angular/core';
import { ISurveyActivity, ISurveyHtml } from '../../../models/survey/ISurveyContent';
import { BaseElement } from '../../base-element.abstract';
import { SurveyElementType } from '../../enum/SurveyElementType';

@Component({
    selector: 'surveys-element-activity',
    templateUrl: './element-activity.component.html',
    styleUrls: ['./element-activity.component.scss']
})
export class ElementActivityComponent extends BaseElement implements OnChanges {
    @Input()
    public element: ISurveyActivity;

    public htmlElement: ISurveyHtml;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges() {
        this.updateHtml();
    }

    protected languageChanged() {
        this.updateHtml();
    }

    private updateHtml() {
        const template = get(this.element, 'data.template', {});
        const keys = get(this.element, 'data.keys', [] as string[]);
        const rawData = get(this.element, 'data.activityData', []);

        const normalizedData: Record<string, any[]> = Array.isArray(rawData)
            ? rawData.reduce((acc, item) => {
                const lang = (item.languageCode || '').toLowerCase();
                if (!acc[lang]) {
                    acc[lang] = [];
                }
                acc[lang].push(item);
                return acc;
            }, {} as Record<string, any[]>)
            : rawData;

        const data = normalizedData[this.language.toLowerCase()] ?? [];

        const templateWithValues: Record<string, string> = {};
        Object.entries(template).forEach(([key, value]: [string, any]) => {
            templateWithValues[key] = this.mappingValueToHtml(value, keys, data);
        });

        this.htmlElement = {
            id: this.element?.id,
            type: SurveyElementType.HTML,
            data: templateWithValues
        };
    }

    private mappingValueToHtml(html: string, keys: string[], data: Record<string, any>[]): string {
        return data
            .map(item => {
                let replaced = html;
                keys.forEach(key => {
                    const regex = new RegExp(`\\$\\{${key}\\}`, "g"); // match ${key}
                    replaced = replaced.replace(regex, item[key] ?? "");
                });
                return replaced;
            })
            .join("\n");
    }
}
